import {GOODS_DETAIL} from "@COMPONENTS/common/constants";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface GoodsDetail {
	emphasisCd: string;
	goodsCd: string;
	goodsNm: string;
	tourPatInfo: string;
	minPrice: number;
	maxPrice: number;
	minPriceDate: string;
	maxPriceDate: string;
	epiCnt: number;
	rvwAvgScore: number;
	rvwCnt: number;
	goodsTp: string;
	goodsBrandCd: string;
	goodTravelYn: string;
	goodsContents: string;
	webDisplayCls: string;
	goodsTpointContents: string;
	goodsFeaturesList: string;
	goodsTmember: string;
	budgetDiviCd: string; // 예약금 구분
	budgetDiviNm: string; // 예약금 명
	schedulleDiviCd: string; // 예약금 추가
	schedulleDiviNm: string; // 예약금 명
	continentCd: string; // Braze
	continentNm: string; // Braze
	countryCd: string; // Braze
	countryNm: string; // Braze
}

/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const key = "useGoodsDetail";
const getPath = (goodsCd: string): string | null => {
	if (!goodsCd) return null;
	return `${publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH}/api/goods/join-event/${goodsCd}`;
};

/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const goodsDetailAsync = (goodsCd: string) =>
	useConfigureAxios(getPath(goodsCd), {
		method: "GET",
	});

/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const goodsDetailSSR = (goodsCd: string) => {
	const removepath = publicRuntimeConfig.RUNTIME_ENV === "local" ? "" : publicRuntimeConfig.ENV_PRODUCT_API_BASEPATH;
	return useConfigureAxios(`${publicRuntimeConfig.ENV_PRODUCT_API_URL}${getPath(goodsCd).replace(removepath, "")}`, {
		method: "GET",
	});
};

/** ```
 * 상품 정보 조회
 *   `/prdt/api/goods/join-event/{goodsCd}`
 * parameter
 *   `goodsCd` 상품코드
 * ```*/
const useGoodsDetail = (goodsCd: string, options?: Partial<UseQueryOptions<Response<GoodsDetail>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		// staleTime: 1000 * 30 * 60,
		placeholderData: {body: GOODS_DETAIL},
		...options,
	});

export default useGoodsDetail;
export {getPath, key, goodsDetailAsync, goodsDetailSSR};
export type {GoodsDetail};
